import { useEffect } from 'react'

const useSendBasketGtmInfo = (basketData, site, event) => {
    useEffect(() => {
        if (basketData) {
            const items = []

            const item_category = basketData.selected_payment === 'Cash' ? 'Rezervace' : 'Nákup'

            for (const item_ticket of basketData?.items_tickets ?? []) {
                item_ticket?.tickets?.forEach((ticket) => {
                    const index = items.findIndex(
                        (item) =>
                            item.item_variant === ticket?.customer_category?.name &&
                            item.item_name === item_ticket.event.title
                    )

                    if (index === -1) {
                        items.push({
                            affiliation: 'Cinestar',
                            coupon: '',
                            currency: 'CZK',
                            item_id: item_ticket.event.eventid,
                            item_name: item_ticket.event.title,
                            item_brand: site,
                            item_category: item_category,
                            item_category_2: 'Film',
                            item_variant: ticket?.customer_category?.name ?? 'Základní',
                            discount: 0,
                            price: ticket.price,
                            quantity: 1,
                        })
                    } else {
                        items[index].quantity += 1
                    }
                })
            }

            for (const item_voucher of basketData.items_vouchers) {
                items.push({
                    affiliation: 'Cinestar',
                    coupon: '',
                    currency: 'CZK',
                    item_id: item_voucher.voucherid,
                    item_name: item_voucher.name,
                    item_brand: site,
                    item_category: item_category,
                    item_category_2: 'Meal',
                    price: item_voucher.price,
                    quantity: item_voucher.amount,
                })
            }

            dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
            dataLayer.push({
                event: event,
                ecommerce: {
                    currency: 'CZK',
                    value: basketData.price,
                    items,
                },
            })
        }
    }, [])
}

export default useSendBasketGtmInfo
